<template>
  <ModalRoot v-if="dataReady" :title="title" :subtitle="subtitle" :closeByClickingOutside="true"
    @close="close"
    :class="{ 'modal-dialog--small': config.modalSize === 'small' }">
    
    <Content :config="config"
      @title="titleUpdated"
      @subtitle="subtitleUpdated" />
  </ModalRoot>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import Content from './modal/Content.vue'
import InitialData from './modal/logic/ModalAjax'

import ModalRoot from '@/components/ModalRoot.vue'

@Component({
  mixins: [
    InitialData,
  ],
  components: {
    ModalRoot,
    Content,
  },
  props: {
    config: {
      type: Object,
      required: false,
    },
  },
})
export default class Modal extends Vue {
  dataReady = true

  close () {
    this.dataReady = false
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Modal.vue